import { Descriptions, Timeline, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { camelCaseToWord } from '../../../utils/strings';

export const JobStatusChangeLogView = ({ job }) => {
	return (
		<Timeline mode="left" className="ps-2">
			<div className="d-flex justify-content-between mb-3">
				<Tooltip title={dayjs(job.createdAt).fromNow()}>
					<span className="text-muted">posted:</span> {dayjs(job.createdAt).format('ddd, MMM D, YYYY h:mm A')}
				</Tooltip>
			</div>
			{job.statusChangeLog.map(log => (
				<Timeline.Item key={log._id}>
					<div className="d-flex justify-content-between">
						<Tooltip title={dayjs(log.createdAt).fromNow()}>
							{dayjs(log.createdAt).format('ddd, MMM D, YYYY h:mm A')}
						</Tooltip>
					</div>
					<Descriptions layout="horizontal" column={{ xs: 1, md: 3 }} className="my-2" size="small">
						<Descriptions.Item label="From">{camelCaseToWord(log.fromState)}</Descriptions.Item>
						<Descriptions.Item label="To">{camelCaseToWord(log.toState)}</Descriptions.Item>
						<Descriptions.Item label="By">
							<Tooltip title={log.actor.email}>
								{log.actor.profile.firstName} {log.actor.profile.lastName}
							</Tooltip>
						</Descriptions.Item>
					</Descriptions>
				</Timeline.Item>
			))}
		</Timeline>
	);
};
